import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Cardless magazine-style property tile:
 *   - Just the image (rounded-3xl) and text below — no bounding card.
 *   - Image scales gently on hover, title nudges up.
 *   - Aspect ratio is opt-in via the `aspect` prop so the Bento grid can vary.
 */
const PropertyCard = ({ property, aspect = 'aspect-[4/3]' }) => {
  const image =
    property.main_image || (property.all_images && property.all_images[0]) || '';

  return (
    <Link
      to={`/property/${property.id}`}
      className="group block"
      data-testid={`property-card-${property.id}`}
    >
      <div className={`relative w-full ${aspect} rounded-3xl overflow-hidden bg-muted`}>
        {image ? (
          <img
            src={image}
            alt={property.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground">
            No image
          </div>
        )}
      </div>

      <div className="mt-5 px-1 transition-transform duration-300 group-hover:-translate-y-0.5">
        <h3 className="font-serif text-xl text-foreground line-clamp-1 leading-snug">
          {property.title}
        </h3>
        <p className="mt-1 text-sm text-muted-foreground font-light">
          Book on airbnb →
        </p>
      </div>
    </Link>
  );
};

export default PropertyCard;
